// extracted by mini-css-extract-plugin
module.exports = {"added-contacts-list":"added-contacts__added-contacts-list___2t3qE","list-header":"added-contacts__list-header___3XouA details-list__detail-name___1HwzI"};